function parallaxScroll() {
  const parallaxSections = document.querySelectorAll('.parallax-section');

  parallaxSections.forEach(function(section) {
    let image = section.querySelector('.parallax-image');
    let speed = 0.5; // Adjust this value to change the scroll speed
    let yPos = (window.pageYOffset - section.offsetTop) * speed;
    image.style.transform = 'translateY(' + yPos + 'px)';
  });
}

window.addEventListener('scroll', parallaxScroll);